import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="h-screen flex flex-col bg-[#f0f3f9] overflow-hidden p-3 gap-3">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
        <Header onMenuClick={() => setMobileMenuOpen(true)} />
      </div>

      <div className="flex flex-1 min-h-0 gap-3">
        <Sidebar mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />

        <div className="flex-1 flex flex-col bg-white rounded-2xl shadow-sm border border-gray-100 overflow-y-auto min-h-0">
          <main className="flex-1 flex flex-col p-5 lg:p-6">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};
